import { useAuth } from "@/context/AuthContext";
import InstallerDashboard from "@/pages/InstallerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  return user?.role === "super_admin" ? <AdminDashboard /> : <InstallerDashboard />;
}
